<template>
    <router-link
        class="convention-menu-item"
        :class="`convention-menu-item--${type}`"
        :to="fullPath"
    >
        <span class="convention-menu-item__icon">
            <slot name="icon"></slot>
        </span>
        <typo name="body-14-medium">
            {{ label }}
        </typo>
        <v-chip
            @click="scrollToExclusion"
            v-if="hasExclusions"
            color=""
            outlined
            small
            class="exclusion"
            text-color="#0052FF"
        >
            <v-avatar left>
                <v-icon>mdi-alert-circle</v-icon>
            </v-avatar>
            Exclusions
        </v-chip>
    </router-link>
</template>

<script>
import scrollManager from "./managers/scrollManager";

export default {
    props: {
        to: { type: String, required: true },
        label: { type: String, required: true },
        type: { type: String, default: "default" },
        hasExclusions: { type: Boolean, default: false },
    },
    computed: {
        fullPath() {
            return `/espace-client/conventions-collectives/${this.$route.params.conventionId}/${this.$route.params.variantNumber}${this.to}`;
        },
    },
    methods: {
        scrollToExclusion() {
            setTimeout(() => {
                scrollManager.scrollToId("exclusion");
            }, 300);
        },
    },
};
</script>

<style scoped lang="sass">
.convention-menu-item
    position: relative
    height: 65px
    display: flex
    align-items: center
    text-decoration: none
    &:after
        position: absolute
        width: 100%
        bottom: 0
        left: 0
        height: 3px
        background: transparentize($color-secondary, 0.6)
        content: ''
.typo
    text-transform: uppercase
    color: transparentize($color-secondary, 0.6)

.convention-menu-item__icon
    display: inline-flex
    color: transparentize($color-secondary, 0.6)

.convention-menu-item--default.router-link-active
    .typo,
    .convention-menu-item__icon
        color: $color-main
    &:after
        background: $color-main

.convention-menu-item--accent.router-link-active
    .typo,
    .convention-menu-item__icon
        color: $color-menu-item-accent
    &:after
        background: $color-menu-item-accent

.exclusion
    margin-left: auto
    border: none

@media print
    .convention-menu-item
        height: auto

        &::after
            content: none

        &.router-link-active
            .typo
                color: #4a7ab8
                font-size: 24pt
                font-weight: 300

        &:not(.router-link-active)
            display: none
</style>
